import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { call, put, select, all, takeLatest } from 'typed-redux-saga';
import * as api from 'data/api';
import { transformVasGalleryItemDtoToProductItem } from 'data/transformers/product-item';
import { transformVasGalleryPricingDto } from 'data/transformers/vas-gallery-pricing';
import { createSagaErrorBoundary } from 'libs/utils/sagaErrorBoundary';
import { logInVasGalleryScope } from 'components/VasGallery';
import { getFilters, getSelectedDynamicFilters } from 'state/catalog-filters/selectors';
import * as abTestsSelectors from 'state/ab-tests/selectors';
import { transformVasGalleryOrderDto } from 'data/transformers/vas-gallery-order';
import { actions as catalogFiltersActions } from 'state/catalog-filters/slice';
import * as selectors from './selectors';
import { actions } from './slice';
const callWithErrorLogging = createSagaErrorBoundary(logInVasGalleryScope);
export function* fetchVasGallery() {
  const vasGalleryAbTest = yield* select(abTestsSelectors.getAbTestByName('vas_gallery_iteration1_v2'));
  const isVasGalleryAbTestEnabled = vasGalleryAbTest && vasGalleryAbTest.variant !== 'off';

  if (isVasGalleryAbTestEnabled) {
    const filters = yield* select(getFilters);
    const selectedDynamicFilters = yield* select(getSelectedDynamicFilters);
    const transformedDynamicFilters = selectedDynamicFilters.reduce((dynamicFilters, filter) => {
      const dynamicFilter = Object.keys(filters).find(key => key.includes(filter.type));
      return _objectSpread(_objectSpread({}, dynamicFilters), dynamicFilter && {
        [dynamicFilter]: filter.ids
      });
    }, {});
    const response = yield* call(api.getVasGallery, _objectSpread(_objectSpread({}, filters), transformedDynamicFilters));

    if ('errors' in response) {
      yield put(actions.fetchVasGalleryFailure());
      return;
    }

    const items = yield* all(response.items.map(item => call(transformVasGalleryItemDtoToProductItem, item)));
    yield put(actions.fetchVasGallerySuccess({
      items
    }));
  }
}
export function* fetchVasGalleryPricing() {
  const selectedItemIds = yield* select(selectors.getSelectedIds);
  const response = yield* call(api.getVasGalleryPricing, selectedItemIds);

  if ('errors' in response) {
    yield put(actions.fetchVasGalleryPricingFailure());
    return;
  }

  const vasGalleryPricing = yield* call(transformVasGalleryPricingDto, response.pricing);
  yield put(actions.fetchVasGalleryPricingSuccess({
    vasGalleryPricing
  }));
}
export function* startCheckout() {
  yield put(actions.postVasGalleryOrderRequest());
  const selectedItemIds = yield* select(selectors.getSelectedIds);
  const response = yield* call(api.postVasGalleryOrder, selectedItemIds);

  if ('errors' in response) {
    yield put(actions.postVasGalleryOrderFailure());
    return;
  }

  const vasGalleryOrder = yield* call(transformVasGalleryOrderDto, response.vas_gallery_order);
  yield put(actions.postVasGalleryOrderSuccess({
    vasGalleryOrder
  }));
}
export function* getVasGalleryOrder(_ref) {
  let {
    payload: {
      orderId
    }
  } = _ref;
  const response = yield* call(api.getVasGalleryOrder, orderId);

  if ('errors' in response) {
    yield put(actions.getVasGalleryOrderFailure());
    return;
  }

  const vasGalleryOrder = yield* call(transformVasGalleryOrderDto, response.vas_gallery_order);
  yield put(actions.getVasGalleryOrderSuccess({
    vasGalleryOrder
  }));
}
export default function* saga() {
  yield* takeLatest(actions.startCheckout, callWithErrorLogging(startCheckout));
  yield* takeLatest([actions.fetchVasGalleryRequest, catalogFiltersActions.removeFilter, catalogFiltersActions.removeFilters, catalogFiltersActions.toggleColorFilterOption, catalogFiltersActions.toggleStatusFilterOption, catalogFiltersActions.toggleBrandFilterOption, catalogFiltersActions.toggleSizeFilterOption, catalogFiltersActions.toggleVideoGameRatingFilterOption, catalogFiltersActions.sizeFilterSet, catalogFiltersActions.catalogFilterSet, catalogFiltersActions.setQuery, // dynamic filters actions
  catalogFiltersActions.setSelectedDynamicFilter, catalogFiltersActions.setSelectedDynamicFilters, catalogFiltersActions.removeSelectedDynamicFilterId, catalogFiltersActions.removeSelectedDynamicFilter, catalogFiltersActions.removeSelectedDynamicFilters], callWithErrorLogging(fetchVasGallery));
  yield* takeLatest(actions.getVasGalleryOrderRequest, getVasGalleryOrder);
  yield* takeLatest(actions.fetchVasGalleryPricingRequest, callWithErrorLogging(fetchVasGalleryPricing));
}